import { DictContext } from "@/layout/context/DictContext";
import { Select, SelectProps } from "antd";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

type SelectShipStatusPros<T> = Omit<SelectProps<T>, "options">

function SelectShipStatus<T>(props: SelectShipStatusPros<T>) {
  const { t } = useTranslation();
  const { shipStatus } = useContext(DictContext);

  return (
    <Select
      {...props}
      options={
        shipStatus.map(type => ({ key: type.key, label: type.desc, value: type.key }))
      }
      placeholder={t('shipment.status')}
    />
  )
};

export default SelectShipStatus;
